export default __webpack_public_path__ + "static/media/10.014ff357.png";